// extracted by mini-css-extract-plugin
export default {"content":"HomePage_content__Yf3v-","homeHeader":"HomePage_homeHeader__ymFmC"};